export default "__VITE_ASSET__BfgBKdDo__"